// providers/housecallPro.ts
import * as Api from '@ViewModels';
import { provider, providerTag } from './helpers';

export const housecallProConfig = provider(Api.IntegrationProvider.HousecallPro, {
	displayName: 'Housecall Pro',
	showConnections: false,

	configuration: {
		showOAuthClientCredentials: false,
		showSyncUser: false,
	},

	main: {
		writebacks: false,
	},

	showKeyFacts: false,

	tags: {
		coreTags: true,
		customFields: true,
		providerTags: [
			providerTag('DoNotService', 'Do Not Service'),
			providerTag('NotificationsEnabled', 'Notifications Enabled'),
			providerTag('BusinessUnit', 'Business Unit'),
			providerTag('LeadSource', 'Lead Source'),
		],
	},
});
